<template>
  <div>
    <b-button variant="outline-light" v-on:click="getDetay()" size="sm"
      ><Icon
        icon="majesticons:checkbox-list-detail-line"
        width="25"
        height="25"
        v-b-tooltip.hover.bottom="'DETAY'"
        color="#7367F0"
    /></b-button>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon
  },
  methods: {
    getDetay() {
      this.$root.$emit("getxmlStokList", this.params.data);
    }
  }
};
</script>
